export const CREATE_NOTIFICATION_START = "CREATE_NOTIFICATION_START";
export const CREATE_NOTIFICATION_SUCCESS = "CREATE_NOTIFICATION_SUCCESS";
export const CREATE_NOTIFICATION_FAILURE = "CREATE_NOTIFICATION_FAILURE";
export const GET_NOTIFICATION_LIST_START = "GET_NOTIFICATION_LIST_START";
export const GET_NOTIFICATION_LIST_SUCCESS = "GET_NOTIFICATION_LIST_SUCCESS";
export const GET_NOTIFICATION_LIST_FAILURE = "GET_NOTIFICATION_LIST_FAILURE";
export const SET_LATEST_NOTIFICATION = "SET_LATEST_NOTIFICATION";
